import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=25d7fda4"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=25d7fda4&prod&lang=scss"
import style1 from "./Footer.vue?vue&type=style&index=1&id=25d7fda4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports